import { Music } from "Pages";
import { MusicNote } from "@mui/icons-material";

const MusicContent = {
  title: "Music",
  spotifyPlaylistURL:
    "https://open.spotify.com/playlist/0CFuMybe6s77w6QQrJjW7d?si=0ac03e74cef446c4",
  icon: <MusicNote />,
  path: "/media/music",
  subMenu: true,
  menuIndex: 0,
  element: <Music />,
};

export default MusicContent;
